import { useEffect, useMemo, useState } from "react";
import api from "@/lib/api";
import { toast } from "sonner";
import { Mail } from "lucide-react";
import { TrialStats, TrialRulesCard, TrialGrantCard, TrialRow } from "./trials/TrialParts";

const fail = (e) => toast.error(e?.response?.data?.detail || "Failed");

export default function PlatformTrials({ settings, setSettings, saveSettings, companies }) {
  const [d, setD] = useState(null);
  const [grant, setGrant] = useState("");
  const load = () => api.get("/platform/trials").then((r) => setD(r.data)).catch(() => {});
  useEffect(() => { load(); }, []);
  const rules = { ...(d?.rules || {}), ...(settings.trial || {}) };
  const setRule = (k, v) => setSettings({ ...settings, trial: { ...rules, [k]: v } });
  const doGrant = async () => {
    if (!grant) return;
    try { await api.post(`/platform/companies/${grant}/trial`, {}); toast.success("Trial granted"); setGrant(""); load(); } catch (e) { fail(e); }
  };
  const runReminders = async () => {
    try { const { data } = await api.post("/platform/trials/run-reminders"); toast.success(`Reminders: ${data.sent} sent · ${data.skipped} skipped of ${data.checked}`); load(); } catch (e) { fail(e); }
  };
  const resend = async (t, kind) => {
    try { await api.post(`/platform/trials/${t.id}/email/${kind}`); toast.success(`${kind} email sent to ${t.email}`); load(); } catch (e) { fail(e); }
  };
  const grantable = useMemo(() => {
    const tried = new Set((d?.trials || []).map((t) => t.workspace_id));
    return companies.filter((c) => c.status === "none" && !tried.has(c.workspace_id));
  }, [d, companies]);
  if (!d) return <div className="text-slate-400 p-4">Loading trials…</div>;
  return (
    <div data-testid="platform-trials">
      <TrialStats d={d} />
      <div className="grid grid-cols-1 lg:grid-cols-3 gap-4 mb-6">
        <TrialRulesCard rules={rules} setRule={setRule} saveSettings={saveSettings} />
        <TrialGrantCard grant={grant} setGrant={setGrant} grantable={grantable} doGrant={doGrant} />
      </div>
      <div className="sc-card p-5" data-testid="trials-table">
        <div className="flex items-center justify-between mb-3"><div className="label-cap">Trials</div>
          <button onClick={runReminders} className="text-xs border border-slate-700 hover:border-amber-500 text-slate-200 px-3 py-1 rounded inline-flex items-center gap-1" data-testid="run-trial-reminders-button"><Mail className="w-3.5 h-3.5" /> Run reminder emails now</button></div>
        <table className="sc-table w-full text-xs"><thead><tr><th>Company</th><th>Email</th><th>Started</th><th>Ends</th><th>Reviews</th><th>Projects</th><th>State</th><th>Granted by</th><th>Welcome</th><th>Reminder</th></tr></thead>
          <tbody>{d.trials.map((t) => <TrialRow key={t.id} t={t} resend={resend} />)}</tbody></table>
        {!d.trials.length && <div className="text-xs text-slate-500">No trials yet.</div>}
      </div>
    </div>
  );
}
